import { createSlice } from '@reduxjs/toolkit';

const sliceUser = createSlice({
  name: 'userTypeName',
  initialState: {
    userType: '',
    userSaveNotebook: false,
    userObjectHomework: {},
    user: null,
    notificationFlagUser: false,
    langState: localStorage.getItem('selectedLanguage'),
  },
  reducers: {
    setAuthUser(state, action) {
      state.user = action.payload;
      state.userType = action.payload?.type || '';
      state.userSaveNotebook = false;
      state.userObjectHomework = {};
      state.notificationFlagUser = false;
    },
    setUserType(state, action) {
      state.userType = action.payload;
    },
    setSaveNotebook(state, action) {
      state.userSaveNotebook = action.payload;
    },
    setObjectHomework(state, action) {
      state.userObjectHomework = action.payload;
    },
    setUserItem(state, action) {
      state.user = action.payload;
    },
    toggleNotificationFlagUser(state) {
      state.notificationFlagUser = !state.notificationFlagUser;
    },
    setNotificationFlagUser(state, action) {
      state.notificationFlagUser = action.payload;
    },
    setLangType(state, action) {
      state.langState = action.payload;
    },
  },
});

export const {
  toggleNotificationFlagUser,
  setAuthUser,
  setUserType,
  setSaveNotebook,
  setObjectHomework,
  setUserItem,
  setNotificationFlagUser,
  setLangType,
} = sliceUser.actions;

export const getUserType = state => state.userTypeName.userType;
export const getSaveNotebook = state => state.userTypeName.userSaveNotebook;
export const getObjectHomework = state => state.userTypeName.userObjectHomework;
export const getUser = state => state.userTypeName.user;
export const getNotificationFlagUser = state => state.userTypeName.notificationFlagUser;
export const getLangType = state => state.userTypeName.langState;

export default sliceUser.reducer;
